angular.module('tf.services')

    .factory('HttpService', ['$http','WebSocketService', '$rootScope', function ($http, WebSocketService, $rootScope) {
        var http = {};

        var baseApiURI = '/api/';

        http.get = function (url, params, subscribe, config) {
            var fullURL = baseApiURI + url;
            if(params){
                fullURL += "?";
                for(var key in params){
                    fullURL += key + "=" + params[key] + "&";
                }
                fullURL = fullURL.slice(0, -1);
            }
            var cid = uuid();
            var req = {
                method: 'GET',
                url: fullURL,
                headers: {
                    'cid': cid,
                    'farm-id' : $rootScope.farmId
                }
            };
            if(config){
                angular.extend(req, config);
            }
            var promise = $http(req);
            if(subscribe) {
                WebSocketService.subscribe(cid, $rootScope.farmId? {farm : $rootScope.farmId} : null);
            }
            return promise;
        };


        http.post = function (url, data, subscribe) {
            var cid = uuid();
            var req = {
                method: 'POST',
                url: baseApiURI + url,
                headers: {
                    'cid': cid,
                    'farm-id' : $rootScope.farmId
                },
                data : data
            };
            var promise = $http(req);
            if(subscribe) {
                WebSocketService.subscribe(cid, $rootScope.farmId? {farm : $rootScope.farmId} : null);
            }
            return promise;
        };

        http.setWS = function(ws){
            http.ws = ws;
        };

        return http;
    }])
;


function uuid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
}
